import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { Close } from '../../Icons/Close';
import { AtYourServiceProps } from '../../interfaces/components';
import { useTranslation } from 'react-i18next';
import CSImage from '../../assets/images/laroca/con_service.png';
import CSImageMobile from '../../assets/images/laroca/con_service_mb.png';
import { PassportCircle } from '../../Icons/PassportCircle';
import useWindowDimensions from '../../utils/hooks/useWindowDimensions';

const AtYourService = ({ active, setActive }: AtYourServiceProps) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  // const whatsappLink = () => {
  //   window.open('https://wa.me/34938423939', '_blank');
  // };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        width={['100vw', '100vw', '760px', '1000px', '1000px']}
        height={['100%', '100%', '580px', '700px', '700px']}
        overflowY={['auto', 'auto', 'hidden']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box display="flex" flexDirection={['column', 'column', 'row']}>
          <Image
            src={width < 770 ? CSImageMobile : CSImage}
            w={['100%', '100%', '360px', '450px']}
            h={['350px', '400px', '580px', '700px']}
            objectFit="cover"
            alt="cs"
          />
          <Box>
            <Text
              mt={['5', '5', '10']}
              textAlign="center"
              fontWeight="400"
              fontFamily="SangBleuBPLight"
              fontSize={['16px', '16px', '18px', '20px', '20px']}
              pt={['0', '0', '2', '5']}
              maxW="80%"
              mx="auto"
              whiteSpace="pre-line"
            >
              {t('con_service_title')}
            </Text>

            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap={['4', '4', '3', '4']}
              mx="auto"
              my={['10', '10', '6', '10']}
              maxW={['80%', '80%', '90%', '70%']}
            >
              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
                whiteSpace="pre-line"
              >
                {t('con_service_benefit_one')}
              </Text>
              <PassportCircle stroke="#C29F6B" boxSize="10px" />

              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
              >
                {t('con_service_benefit_two')}
              </Text>
              <PassportCircle stroke="#C29F6B" boxSize="10px" />

              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
              >
                {t('con_service_benefit_three')}
              </Text>
              <PassportCircle stroke="#C29F6B" boxSize="10px" />

              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
                whiteSpace="pre-line"
              >
                {t('con_service_benefit_four')}
              </Text>
              <PassportCircle stroke="#C29F6B" boxSize="10px" />

              <Text
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '14px', '14px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
              >
                {t('con_service_benefit_five')}
              </Text>
            </Box>

            <Box display="flex" justifyContent="center" pb={['10', '10', '0']}>
              <Text
                as="i"
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '12px', '15px', '15px']}
                lineHeight={['16px', '16px', '16px', '18px', '18px']}
                className="gold"
                maxW="320px"
                whiteSpace="pre-line"
              >
                {t('con_service_contact')}
                {/* <br />
                contactus@larocavillage.com
                <br />
                +34 93 842 39 39 */}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AtYourService;
